import { UserSearch } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { ashbyWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  ashbyWeb,
  {
    AshbyPage: () => import('./AshbyPage'),
    AshbyPagePreview: () =>
      import('./AshbyPagePreview').then((m) => ({ default: m.AshbyPagePreview })),
  },
  {
    icons: { UserSearch },
  },
);
